import React, { Component } from 'react'
import { connect } from 'react-redux'
import '../../styles/main.css'
import {LOGIN, TOKEN_NAME} from '../../constants/actionTypes'
import {Form} from 'react-bootstrap'
//import { Link} from 'react-router-dom'
import agent from '../../agent'
import { Cookies } from 'react-cookie'
import Avatar from 'react-avatar';
import SystemCheckUp from '../Home/SystemCheckUp'
import ReactLoading from 'react-loading';

const mapDispatchToProps = dispatch => ({               
	onLogin: (redirectTo, token) => {
		dispatch({ type: LOGIN, redirectTo, token})  
	}
	
});
	
class Login extends Component {	
	constructor(){
		super()
		this.state = {
			password: '',username:'',error:'',remem:false,school_id:'',
			//school_logo:'/media/home/logo.png',
			school_logo: '', show_system_checkup: false,
			school_name:'L O G O',role:'',subdomain:'',help_link:'',isLoading:false
		}
		this.getSchool=()=>{
			//let host='dime.adlsassist.com';//'esmec.adlsassist.com'
			let host=window.location.hostname
			host= host.split(".")
			console.log(window.location.hostname)
			//console.log(host[0],host)
			//let subdomain=host[0]
			let subdomain=window.location.hostname;
			let school_id=1
			let pathname=window.location.search;
			pathname=pathname.split("?id=");
			//pathname=pathname.split("=");
			//console.log(pathname)
			
			if(pathname[1]!==undefined && parseInt(pathname[1])>0 && parseInt(pathname[1])!==school_id){
				school_id=pathname[1];
			}
			//console.log(params)
			//let school_id=parseInt(params)
			//subdomain='eos'
			window.localStorage.setItem('pathname',window.location.search)
			agent.auth.getSchool({school_id:school_id,subdomain:subdomain,key:'d9wj3nif#(&%0dfj2(@*&#&$'}).then(data => {				
				if(data.status === true){
					if(data.data!=null && data.data!=''){
						let help_link=data.data.help_link;
						this.setState({school_logo:data.data.school_logo,school_name:data.data.school_name,
							subdomain:subdomain,help_link:help_link})
					}
				} else {
					//this.setState({error: data.message})
					
				}
			})			
		}
		this.auto_login=(token)=>{
			window.localStorage.setItem('nosettimezone','')
			agent.auth.auto_login(token).then(data => {
				//console.log(data)
				if(data.status === true){
					window.localStorage.setItem('username','');
					let UserInfo=data.data;
					const cookies = new Cookies()
					const expires_in = data.expires_in / 60 / 60 / 24
					let dat = new Date()
					//dat.setDate(dat.getDate() + expires_in)	
					dat.setTime(dat.getTime() + (1*24*60*60*1000));	
					//cookies.set(TOKEN_NAME, UserInfo.token, {expires: dat})
					this.setCookie(TOKEN_NAME, UserInfo.token, 1)
					window.localStorage.setItem('TOKEN_NAME',UserInfo.token)
					cookies.set('USERLOG', UserInfo, {expires: dat})
					//this.setCookie('USERLOG', UserInfo, 1)
					//console.log(UserInfo)
					window.localStorage.setItem('USERLOG',JSON.stringify(UserInfo))
					let name=UserInfo.fname;
					name=name.split(" ");
					window.localStorage.setItem('NAMEINFO',name[0])
					window.localStorage.setItem('EMAIL',UserInfo.email)
					agent.setToken(UserInfo.token)
					this.props.onLogin('home',UserInfo.token);
						
					window.location.href = '/home'
				}
			})
		}
		this.showSystemCheckUp = () => {
			this.setState({show_system_checkup: true});
		}
		this.hideSystemCheckUp = () => {
			this.setState({show_system_checkup: false});
		}
	}
	
	handleChange(field, e){
		this.setState({[field]: e.target.value, error: ''})
	}
	setCookie(name,value,days) {
		const cookies = new Cookies()
		var expires = "";
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days*24*60*60*1000));
			//date.setTime(date.getTime() + (days*1*2*60*1000));
			expires = "; expires=" + date.toUTCString();
			console.log(date)
			cookies.set(name, value, {expires: date})
		}
		//document.cookie = name + "=" + (value || "")  + expires + "; path=/";
		
	}
	handleLogin(e){		
		window.localStorage.setItem('nosettimezone','');
		let hosts=window.location.hostname
		hosts= hosts.split(".")
		let hostis=(hosts!==undefined && hosts!==null && hosts[0]!==undefined)?hosts[0]:''
		//console.log(hostis)
		const state = this.state
		if(e.key === 'Enter' || !e.key){
			//let role=(hostis==="teacher")?3:(hostis==="sadmin" || hostis==="portal")?2:(hostis==="superadmin" || hostis==="sa")?1:state.role;
			//let role=(hostis==="teacher")?3:(hostis==="sadmin")?2:(hostis==="superadmin")?1:1;
			//let role=1;
			let role = state.role;
			if (hostis != 'localhost' && hostis != 'staging' && hostis != 'prerelease') {
				role = (hostis === "teacher") ? 3 : (hostis === "sadmin" || hostis === "portal") ? 2 : (hostis === "sa") ? 1 : 2;
			}
			this.setState({ isLoading: true });
			agent.auth.doLogin({username: state.username, password: state.password, role :role ,subdomain:this.state.subdomain,web:1 }).then(data => {
				//console.log(data)
				this.setState({ isLoading: false });
				if(data.status === true){
					window.localStorage.setItem('username','');
					//set cookies
					let UserInfo=data.data;
					let last_role=parseInt(UserInfo.last_role);
					//let UserInf=JSON.stringify(UserInfo)
					const cookies = new Cookies()
					const expires_in = data.expires_in / 60 / 60 / 24
					let dat = new Date()
					//dat.setDate(dat.getDate() + expires_in)	
					dat.setTime(dat.getTime() + (1*24*60*60*1000));	
					//cookies.set(TOKEN_NAME, UserInfo.token, {expires: dat})
					this.setCookie(TOKEN_NAME, UserInfo.token, 1)
					window.localStorage.setItem('TOKEN_NAME',UserInfo.token)
					cookies.set('USERLOG', UserInfo, {expires: dat})
					//this.setCookie('USERLOG', UserInfo, 1)
					//console.log(UserInfo)
					let name_log=(last_role===1)?'USERLOGSUP':'USERLOG';
					window.localStorage.setItem(name_log,JSON.stringify(UserInfo))
					let name=UserInfo.fname;
					name=name.split(" ");
					window.localStorage.setItem('NAMEINFO',name[0])
					window.localStorage.setItem('EMAIL',UserInfo.email)
					agent.setToken(UserInfo.token)
					this.props.onLogin('home',UserInfo.token);
					if(this.state.remem){
						cookies.set('username', state.username)
						cookies.set('password', state.password)
						//localStorage.username = state.username
						//localStorage.pass = state.password
					}
					
					let changepassword=parseInt(UserInfo.changepassword);
					//console.log(changepassword)
					let host=window.location.hostname
					host= host.split(".")
					let hosti=(host!==undefined && host!==null && host[0]!==undefined)?host[0]:''
					//console.log(last_role,host)	
					let href = window.sessionStorage.getItem('previous_href');
					href = (href!=undefined && href!=null && href.length > 0 )? href : '/home';

					if(last_role===4 && changepassword===1){
						window.location.href = '/change-password'
					}else if(last_role===3 || last_role===4 || last_role===5){
						window.location.href = href;
					//}else if(last_role===2 && (hosti==="sadmin" || hosti==="localhost" || hosti==='staging')){						
					}else if(last_role===2 || last_role===1){					
						window.location.href = href;
						
					}else{
						
						let sso_portal=UserInfo.sso_portal;
						let a= document.createElement('a');
						a.href= sso_portal;
						a.click();
						var cookiess = document.cookie.split(";");

						for (var i = 0; i < cookiess.length; i++) {
							var cookie = cookiess[i];
							var eqPos = cookie.indexOf("=");
							var names = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
							document.cookie = names + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
						}
					}
					window.localStorage.setItem('last_role',last_role);
					window.localStorage.setItem('enrollParams','');
					//console.log(last_role)
					
					//console.log( UserInfo.token)
				} else {
					this.setState({error: data.message})
					//this.setState({error: 'Password is incorrect'})
				}
			})			
		}
	}
	componentWillMount() {
		//---
		
		//console.log(username,password)
		let pathname=window.location.search;
		pathname=pathname.split("?token=");
		//console.log(pathname)
		if(pathname[1]!==undefined && pathname[1]!==''){
			this.auto_login(pathname[1]);
		}else{
			this.getSchool();
			const cookies = new Cookies();
			let username=cookies.get('username');
			let password=cookies.get('password');
			if(username!==undefined && password!==undefined){
				this.setState({username:username,password:password})
			}
		}
		let last_role=window.localStorage.getItem('last_role');
		if(last_role!=undefined && last_role!=null){
			this.setState({role:last_role})
		}
		//console.log(last_role)
		
	}	
	componentWillUnmount() {
	  //window.removeEventListener('resize', this.handleWindowSizeChange);
	}
	componentWillReceiveProps(nextProps) {
		
	}
	componentDidMount() {
		
	}
	handlecheck(field,ev){
		//console.log(field,ev.target.checked)
		this.setState({[field]:ev.target.checked})
	}
    render() {
		let host=window.location.hostname
		host= host.split(".")
		let hosti=(host!==undefined && host!==null && host[0]!==undefined)?host[0]:''
		let help_link=this.state.help_link;
		return (
			<div>
				 <header className="login-header">
					<div className="container">
						<div className="login-logo">
						{/*(this.state.school_logo!=='')?<img src={this.state.school_logo} alt="Images"/>:<img src='/media/login/login-logo.png' alt="Images"/>*/}
						{(this.state.school_logo!=='')?<img src={this.state.school_logo} alt="Images"/>:
							<Avatar size="60" round={true} className="avatar-title" 
							color={'#00a2a7'} name={this.state.school_name} />
						}
							<h6 className="ml-3 mb-0 max-w-250px font-weight-bold" style={{'display':'none'}}>{this.state.school_name}</h6>
						</div>
					</div>
				</header>
				<div className="login-content-area">
					<div className="container d-flex align-items-center" style={{minHeight: '700px'}}>
						<div className="login-content">
							{(hosti=="alvs")?<div className="alvs">
								<p>Please bookmark this page: <a href="https://edm.geniussis.com">https://edm.geniussis.com</a>.</p>
								<p>This will be your new system effective July 25th, 2022, and on that day you will receive an email with your username and password to access your courses.</p>
							</div>:''}
							<div className="login-heading">
								<h1>Log in</h1>
							</div>
							<div className="login-form">
								<form action="">
									<div className="single-login-form">
										<label >Username</label>
										<input type="text" placeholder="Username" id="username" value={this.state.username} onChange={this.handleChange.bind(this,'username')}/> 
									</div>
									<div className="single-login-form">
										<label >Password</label>
										<input type="password" placeholder="Password" id="password" value={this.state.password} onChange={this.handleChange.bind(this,'password')}/> 
									</div>
									<div className="single-login-form" style={{'display':(hosti=='localhost' || hosti=='staging' || hosti=='prerelease')?'':'none'}}>
										<label >Role</label>
										<Form.Control as="select" className="role-login" id="select-resource1" value={this.state.role}  onChange={this.handleChange.bind(this,'role')}>
											{(hosti=="localhost" || hosti=='staging' || hosti=='prerelease')?<option value="1">Super Admin</option>:''}
											<option value="2">Admin</option>
											<option value="3">Teachers</option>
											<option value="4">Student</option>
											<option value="5">Parent/Mentor</option>
										</Form.Control>
									</div>
									
									<div className="single-login-checkbox-form" >										
									    <Form.Check 
											type="checkbox"
											id="html"
											label="Remember me"
											onChange={this.handlecheck.bind(this,'remem')} checked={this.state.remem}
										  />
								   </div>
								   <div className="">
										<span className="txt-error">{this.state.error}</span>										
									</div>
									<div className="single-login-submit-button">
										<input type="button" value="Log in" onClick={this.handleLogin.bind(this)}/>
									</div>
									{this.state.isLoading &&
										<div className='d-flex justify-content-center w-100 mt-2'>
											<ReactLoading type="spinningBubbles" color="#00BFFF" height={30} width={30} />
										</div>
									}
								</form>
								<div className="login-form-text">
									<a href={"/forgot-password?id="+this.state.school_id}>Forgot your password?</a>
									
								   <a href="#" style={{'display':'none'}}><span>Are you a parent?</span> Set your password and activate your account</a>
								</div>
							</div>

							<div className="login-form-logo">
								<a href="#"><img src="/media/login/login-logo.png" alt="Images"/></a>
							</div>
						</div>
					</div>
				</div>
				{this.state.show_system_checkup && 
					<SystemCheckUp onCallback={this.hideSystemCheckUp}/>
				}
				 <div className="login-footer-area">
					<div className="container">
						<div className="login-footer-content-">
							<div className="login-footer-top-content">
								<div className="login-footer-top-left-content">
									<a href="#"><img src="/media/login/login-footer-logo.png" alt="Images"/></a>
								</div>
								<div className="login-footer-top-right-content">
									<div className="single-login-footer-right mr-2">
										<a href='#' onClick={this.showSystemCheckUp.bind(this)}>Run System Check-Up</a>
									</div>
									 <div className="single-login-footer-right">
										{/*<a href="mailto:support@advantages-dls.com">Contact Support</a>*/}
										<a href={help_link}>Contact Support</a>
									</div>
								</div>
							</div>
							<div className="login-footer-bottom-content">
								<p>2021 © ASSIST <span>/</span> All Rights Reserved <span>/</span> <a target="_blank" href="/media/login/ASSIST_Privacy_Policy_2024.pdf">Privacy</a> <span>/</span> <a target="_blank" href="/media/login/Terms_of_Use.pdf">Terms of Use</a></p>
							</div>
						</div>
					</div>
				</div>
				
			</div>
		)

	}
}

export default connect(null, mapDispatchToProps)(Login)
